import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './layout/AppLayout';
import { ProtectedRoute } from './layout/ProtectedRoute';
import { LoginPage } from './modules/login/LoginPage';
import { OverviewPage } from './modules/overview/OverviewPage';
import { CustomersPage } from './modules/customers/CustomersPage';
import { QuotationsPage } from './modules/quotations/QuotationsPage';
import { ContractsPage } from './modules/contracts/ContractsPage';
import { DeliveriesPage } from './modules/deliveries/DeliveriesPage';
import { InspectionsPage } from './modules/inspections/InspectionsPage';
import { PriceListsPage } from './modules/price-lists/PriceListsPage';
import { DiscountRulesPage } from './modules/price-lists/DiscountRulesPage';
import { ItemsPage } from './modules/items/ItemsPage';
import { ItemGroupsPage } from './modules/items/ItemGroupsPage';
import { CompanyProfilePage } from './modules/settings/CompanyProfilePage';
import SystemBackupsPage from './modules/settings/SystemBackupsPage';
import { PortalAdminPage } from './modules/portal-admin/PortalAdminPage';
import { UsersPage } from './modules/users/UsersPage';
import { WebsiteAdminPage } from './modules/website/WebsiteAdminPage';
import { OpenWebsiteCmsPage } from './modules/website/OpenWebsiteCmsPage';
import { SetPasswordPage } from './modules/set-password/SetPasswordPage';
import { OperationsPage } from './modules/operations/OperationsPage';
import { WarehousesPage } from './modules/warehouses/WarehousesPage';
import { BomsPage } from './modules/boms/BomsPage';
import { ProcessTemplatesPage } from './modules/process-templates/ProcessTemplatesPage';
import { MaterialPlansPage } from './modules/material-plans/MaterialPlansPage';
import { QcTemplatesPage } from './modules/qc-templates/QcTemplatesPage';
import { WorkOrdersPage } from './modules/work-orders/WorkOrdersPage';
import { StockPage } from './modules/stock/StockPage';
import { WorkpieceLedgerPage } from './modules/customer-supplied-materials/WorkpieceLedgerPage';
import { PhysicalAssetsPage } from './modules/physical-assets/PhysicalAssetsPage';
import { AssetTraceabilityPage } from './modules/physical-assets/AssetTraceabilityPage';
import { SerialLookupPage } from './modules/physical-assets/SerialLookupPage';
import { LegacySerialsPage } from './modules/physical-assets/LegacySerialsPage';
import { RepairLedgerPage } from './modules/physical-assets/RepairLedgerPage';
import { StandaloneAssetReturnPage } from './modules/physical-assets/StandaloneAssetReturnPage';
import { SuppliersPage } from './modules/suppliers/SuppliersPage';
import { PurchasesPage } from './modules/purchases/PurchasesPage';
import { ReturnsPage } from './modules/returns/ReturnsPage';
import { ReworkPage } from './modules/rework/ReworkPage';
import { AfterSalesPage } from './modules/after-sales/AfterSalesPage';
import { ReworkBatchListPage } from './modules/rework-batches/ReworkBatchListPage';
import { ProductionReworkPage } from './modules/production-rework/ProductionReworkPage';
import { ComingSoon } from './components/ComingSoon';
// 财务：ARCA 税票（开票列表，不门控）与 ARCA 财务专页 / 收款（受 INTEGRAL_ENABLE_FINANCE_READ 门控，
// 见 modules/finance/FinanceGate.tsx）。拆成两页的原因：发票登记与三联 PDF 打印在生产环境
// 仍应可用，应收/收款口径才是刻意关闭的部分。
import { ArcaInvoicesPage } from './modules/finance/ArcaInvoicesPage';
import { ArcaFinancePage } from './modules/finance/ArcaFinancePage';
import { PaymentsPage } from './modules/finance/PaymentsPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* 客户自助设置密码：凭一次性链接即可访问，不要求已登录，
          也不套 core-api 的 ProtectedRoute —— 否则客户拿到链接仍会被弹到登录页。 */}
      <Route path="/set-password" element={<SetPasswordPage />} />
      {/* Portal 管理：使用统一身份的会话（x-integral-session）+ portal.manage 自行鉴权，
          因此同样不嵌套在 core-api 的 ProtectedRoute 内，避免两套登录态互相干扰。 */}
      <Route path="/portal-admin" element={<PortalAdminPage />} />
      {/* 网站管理：官网 CMS 后台的统一入口。员工登录/权限/审计在 Integral 侧，
          页面/博客/媒体/发布在 CMS 后台完成。使用 x-integral-session 自行鉴权，
          与其它统一身份页面一样不嵌套 ProtectedRoute（避免两套登录态互扰）。 */}
      <Route path="/website-admin" element={<WebsiteAdminPage />} />
      {/* 网站管理直达：新标签打开后自动交接并跳转 CMS（免中间页） */}
      <Route path="/website-admin/open" element={<OpenWebsiteCmsPage />} />
      {/* 员工账号管理：统一身份会话 + staff.manage 自行鉴权。
          与 /portal-admin 一样不套 core-api 的 ProtectedRoute —— 它用的是
          x-integral-session 而不是 Bearer，套上去会拿错误的登录态做判断。
          两页的授权位互相独立，持有其一不会获得另一页的权限。 */}
      <Route path="/users" element={<UsersPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/quotations" element={<QuotationsPage />} />
          <Route path="/contracts" element={<ContractsPage />} />
          <Route path="/deliveries" element={<DeliveriesPage />} />
          <Route path="/items" element={<ItemsPage />} />
          <Route path="/item-groups" element={<ItemGroupsPage />} />
          <Route path="/company" element={<CompanyProfilePage />} />
    <Route path="/system-backups" element={<SystemBackupsPage />} />

          <Route path="/leads" element={<ComingSoon label="销售线索" endpoint="/api/leads" phase={2} />} />
          <Route path="/boms" element={<BomsPage />} />
          <Route path="/process-templates" element={<ProcessTemplatesPage />} />
          <Route path="/material-plans" element={<MaterialPlansPage />} />
          <Route path="/work-orders" element={<WorkOrdersPage />} />
          <Route path="/customer-supplied-materials" element={<WorkpieceLedgerPage />} />
          <Route path="/physical-assets" element={<PhysicalAssetsPage />} />
          <Route path="/asset-traceability" element={<AssetTraceabilityPage />} />
      <Route path="/repair-ledger" element={<RepairLedgerPage />} />
      <Route path="/repair-returns" element={<StandaloneAssetReturnPage />} />
          <Route path="/serials" element={<SerialLookupPage />} />
          <Route path="/legacy-serials" element={<LegacySerialsPage />} />
          <Route path="/operations" element={<OperationsPage />} />
          <Route path="/stock" element={<StockPage />} />
          <Route path="/warehouses" element={<WarehousesPage />} />
          <Route path="/suppliers" element={<SuppliersPage />} />
          <Route path="/purchase-orders" element={<PurchasesPage />} />
          <Route path="/price-lists" element={<PriceListsPage />} />
          <Route path="/discount-rules" element={<DiscountRulesPage />} />
          <Route path="/inspections" element={<InspectionsPage />} />
          <Route path="/qc-templates" element={<QcTemplatesPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/rework" element={<ReworkPage />} />
          <Route path="/after-sales" element={<AfterSalesPage />} />
          <Route path="/rework-batches" element={<ReworkBatchListPage />} />
<Route path="/production-rework" element={<ProductionReworkPage />} />
          <Route path="/arca-invoices" element={<ArcaInvoicesPage />} />
          <Route path="/arca-finance" element={<ArcaFinancePage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/users" element={<ComingSoon label="用户与权限" endpoint="/api/users" phase={3} />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
